<flx-test-modal
  [previewMode]="previewMode()"
  [sections]="sections"
  (testModalClose)="onClose()"
  title="Business Rule"
>
  <ng-container leftSection>
    <flx-scripting-input-data
      [processDefinitionName]="processDefinitionName()"
      [(data)]="input"
      class="grow"
    />
  </ng-container>
  <ng-container middleSection>
    <flx-scripting-edit
      [processVersionId]="processDefinitionId()"
      [autocompleteOptions]="autoCompleteOptions"
      [showLangSelect]="true"
      [canReferenceFunctions]="true"
      [withFixWarnings]="withFixWarnings()"
      [readonly]="readonly()"
      [conversationTargetDescriptor]="conversationTargetDescriptor()"
      [enableAiActions]="true"
      [supportsGraalVM]="supportsGraalVM()"
      (save)="onSave($event)"
      (run)="onRun($event)"
      (previewModeChange)="onPreviewModeChange($event)"
      [(useGraalVM)]="useGraalVM"
      [(code)]="expression"
      [(language)]="language"
      class="grow min-h-0"
      contextType="business_rule"
    />
  </ng-container>
  <ng-container rightSection>
    <flx-scripting-output
      [result]="output()"
      [valueIsComputed]="outputIsComputed()"
      [error]="error()"
      [showAiActions]="designerAiAccess()"
      (fixError)="onFixError($event)"
      class="grow"
    />
  </ng-container>
</flx-test-modal>
<!-- TODO: rewire to the AI builder harness. The overlay is raised by the agent's own progress,
     which the old command center held, so it is parked whole rather than left with no trigger.
<div
  class="flex items-center justify-center w-full h-full absolute z-50 left-0 top-0 cursor-not-allowed"
>
  <div
    class="flex flex-col gap-y-6 items-center justify-center w-64 h-64 bg-white rounded-3xl shadow-xl cursor-auto"
  >
    <flx-ai-loader
      [white]="false"
      [title]="fixLoaderTitle()"
    ></flx-ai-loader>

    <button
      (click)="cancelFix()"
      class="flx-ds ternary"
      flxButton
    >
      Cancel
    </button>
  </div>
</div>
-->
